"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _unique = _interopRequireDefault(require("../helpers/unique.id"));

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _button = _interopRequireDefault(require("../Button/button"));

var _icon = _interopRequireDefault(require("../Icon/icon"));

var _ratingOption = _interopRequireDefault(require("./ratingOption"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var handleEvent = function handleEvent(userEvent, index) {
  return function (event) {
    userEvent({
      target: {
        index: index,
        value: event.target.value
      }
    });
  };
};

function processChildren(children, ratingId, small, props) {
  var onChange = props.onChange,
      onMouseEnter = props.onMouseEnter;
  return _react.default.Children.map(children, function (child, index) {
    return _react.default.cloneElement(child, {
      id: child.props.id || "".concat(ratingId, "-").concat(index),
      value: child.props.value || index,
      name: child.props.name || "".concat(ratingId),
      onChange: handleEvent(onChange, index),
      onMouseEnter: handleEvent(onMouseEnter, index)
    });
  });
}

var Rating = function Rating(_ref) {
  var children = _ref.children,
      id = _ref.id,
      tabIndex = _ref.tabIndex,
      small = _ref.small,
      large = _ref.large,
      onClear = _ref.onClear,
      onMouseLeave = _ref.onMouseLeave,
      disabled = _ref.disabled,
      props = _objectWithoutProperties(_ref, ["children", "id", "tabIndex", "small", "large", "onClear", "onMouseLeave", "disabled"]);

  var uid = id || (0, _unique.default)();
  var allowedModifiers = {
    small: small,
    large: large,
    disabled: disabled
  };
  return _react.default.createElement(_styler.default, {
    classNames: "co-rating",
    modifiers: allowedModifiers
  }, function (styles) {
    return _react.default.createElement("div", _extends({
      className: styles,
      id: uid,
      tabIndex: tabIndex
    }, (0, _getNativeProps.default)(props)), _react.default.createElement("div", {
      className: "co-rating__options",
      onMouseLeave: onMouseLeave
    }, processChildren(children, uid, small, props)), onClear ? _react.default.createElement("div", {
      className: "co-rating__actions"
    }, _react.default.createElement(_button.default, {
      onClick: onClear,
      small: small,
      large: large
    }, _react.default.createElement(_icon.default, {
      name: _icon.default.CLEAR,
      medium: !small
    }))) : null);
  });
};

var noop = function noop() {};

var exclusiveSizes = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('small', 'large');
Rating.defaultProps = {
  tabIndex: '-1',
  onMouseLeave: noop
};
Rating.propTypes = {
  /** {---} One of: @@string@@ @@number@@ @@<Icon>@@ */
  children: _propTypes.any.isRequired,
  id: _propTypes.string,
  tabIndex: _propTypes.string,

  /** {bool} Mutually exclusive props: @@small@@ @@large@@ */
  small: exclusiveSizes,

  /** {bool} Mutually exclusive props: @@small@@ @@large@@ */
  large: exclusiveSizes,
  disabled: _propTypes.bool,
  onChange: _propTypes.func,
  onMouseEnter: _propTypes.func,
  onMouseLeave: _propTypes.func,
  onClear: _propTypes.func
};
Rating.Option = _ratingOption.default;
var _default = Rating;
exports.default = _default;
Rating.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Rating",
  "props": {
    "tabIndex": {
      "defaultValue": {
        "value": "'-1'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onMouseLeave": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": "{---} One of: @@string@@ @@number@@ @@<Icon>@@"
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "small": {
      "type": {
        "name": "custom",
        "raw": "exclusiveSizes"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@small@@ @@large@@"
    },
    "large": {
      "type": {
        "name": "custom",
        "raw": "exclusiveSizes"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@small@@ @@large@@"
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onMouseEnter": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onClear": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};